{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Vezi toate opțiunile",
  "Spoiler_Reveal_Tooltip": "Dă clic pentru a afișa",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Publică pe Twitter",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Elementul este restrâns",
  "Spoiler_Reveal_Video_CTA": "Afișează videoclipul",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Extinde imaginea",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Vezi toate rezultatele",
  "Spoiler_Reveal_Image_Placeholder": "Această imagine conține un spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Glisor de navigare",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Poți vota pentru mai multe răspunsuri.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Afișează mai multe comenzi de sunet",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Închide",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Se încarcă {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Citește mai mult",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volum",
  "Spoiler_Reveal_Gallery_Placeholder": "Această galerie conține un spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Rezervă acum",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Dezactivează modul silențios",
  "Spoiler_Reveal_Gallery_CTA": "Afișează Galeria",
  "Poll_Viewer_ShowLess_CTA": "Afișează mai puțin",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Activează modul silențios",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+ {{anonNumber}} anonimi",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Urmărește",
  "VerticalEmbed_Products_Button": "Cumpără acum",
  "Poll_Viewer_Toast_Error_ServerDown": "Nu s-a putut conecta la server. Încearcă mai târziu.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} persoană a votat pentru acest răspuns",
  "Poll_Viewer_VoteCount": "{{number}} voturi",
  "VerticalEmbed_Events_Button": "Înregistrează-te acum",
  "Spoiler_Reveal_Image_CTA": "Afișează imaginea",
  "Poll_Viewer_Toast_Error_Connection": "Fără conexiune la internet. Verifică-ți conexiunea.",
  "Poll_Viewer_Visibility_Owner_Footer": "Doar tu poți vedea rezultatele.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} persoane au votat pentru acest răspuns",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Elementul este expandat",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Acest videoclip conține un spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Vezi toată postarea",
  "UploadFile_Viewer_Download": "Descarcă {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
